module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Black.e4e10e53.woff";